import '.r{flex:1;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.d{align-items:center;}.ssr-plugin'
import '.c{justify-content:center;}.ssr-plugin'
import '.f{width:100%;}.ssr-plugin'
import '.t{height:100%;}.ssr-plugin'
import { styled } from 'inlines'
import { Menu, MenuItemProps, MenuProps } from '../Menu/index.js'
import { IconButton, IconButtonProps } from '../IconButton/index.js'
import { useState } from 'react'
import { PartialByKeys } from '../../utils/common.js'
import React from 'react'
import { IconProps } from '../Icon/index.js'

export type ContextMenuItem =
  | (Omit<MenuItemProps, 'children' | 'style' | 'onClick'> & {
      onClick?: (...value: any) => void
    })
  | null

export type ContextMenuProps = PartialByKeys<
  Omit<MenuProps, 'style'>,
  'children'
> &
  Partial<Pick<IconButtonProps, 'size'>> & {
    icon?: IconProps['variant']
    value?: any
    items?: Record<string, ContextMenuItem>
    disabled?: boolean
    filterable?: boolean
  }

function ContextMenu({
  icon = 'more-horizontal',
  scrollableParent,
  children,
  value,
  items,
  disabled,
  position,
  filterable,
  size = 'regular',
  onOpen,
  onClose,
}: ContextMenuProps) {
  const [contextMenuState, setContextMenuState] = useState<'open' | 'closed'>(
    'closed',
  )
  const childrenArr = []
  let isChildrenValid = true
  let childrenCounter = Object.keys(items || {}).length

  if (!childrenCounter) {
    React.Children.forEach(children, (child) => {
      if (
        !React.isValidElement(child) ||
        (child.type !== Menu.Item && child.type !== Menu.Separator)
      ) {
        isChildrenValid = false
      } else {
        childrenCounter++
        childrenArr.push(child)
      }
    })
  } else {
    Object.values(items).forEach((item) => {
      childrenCounter++
      childrenArr.push(item)
    })
  }

  if (!childrenCounter && !children) {
    isChildrenValid = false
  }

  return (
    <Menu
      scrollableParent={scrollableParent}
      position={position}
      onOpen={() => {
        onOpen?.()
        setContextMenuState('open')
      }}
      onClose={() => {
        onClose?.()
        setContextMenuState('closed')
      }}
    >
      <Menu.Trigger>
        <div className="r a d c f t"
        >
          <IconButton
            disabled={disabled || !isChildrenValid}
            size={size}
            forceHover={contextMenuState === 'open'}
            icon={icon}
          />
        </div>
      </Menu.Trigger>
      <Menu.Items filterable={filterable}>
        {isChildrenValid && childrenCounter
          ? childrenArr
              .filter((item) => Boolean(item))
              .map((item, index) => {
                if (children) {
                  return item
                }

                return (
                  <Menu.Item
                    key={'item-' + item.label + '-' + index}
                    {...item}
                    onClick={() => {
                      if (value && typeof value === 'object') {
                        item?.onClick?.(...Object.values(value))
                      } else {
                        item?.onClick?.(value)
                      }
                    }}
                  />
                )
              })
          : null}
      </Menu.Items>
    </Menu>
  )
}

ContextMenu.Item = Menu.Item
ContextMenu.Separator = Menu.Separator

export { ContextMenu }
